import { Outlet } from '@tanstack/react-router'
import {
  Grid,
  GridItem,
  Flex,
  Box
} from "@chakra-ui/react";
import { Sidebar } from '@/components';
export {
  Sidebar
} from "@/components";
export const DefaultLayout = () => {

  return (
    <Grid
      templateAreas={`"nav main"`}
      gridTemplateRows={'50px 1fr 30px'}
      gridTemplateColumns={'250px 1fr'}
      h='100vh'
      gap='0'
      color='blackAlpha.700'
    >
      <GridItem 
        h="100vh" 
        bg='white' 
        area={'nav'}
        borderRight="1px solid"
        borderColor="gray.100"
      >
        <Sidebar/>
      </GridItem>
      <GridItem h="100vh" bg='gray.50' area={'main'}>
        <Flex
          direction="column"
          h="100%"
        >
          <Box 
            h="calc(100vh - 73px)"
            overflowY="scroll"
            p={8}
          >
            <Outlet/>
          </Box>
          <Box 
            h="73px" 
            pl='8' 
            borderTop="1px solid" 
            borderColor="gray.100"
            bg='white'
            display="flex"
            alignItems="center"
          >
            © 2024 BFC Srl | P.IVA 03149650164.
          </Box>
        </Flex>
      </GridItem>
    </Grid>
  )
}
